import React from "react";

import "./OverlapPlatformBox.scss";
import { SOCIAL_ICONS, SOCIAL_LABELS } from "src/types";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

export const OverlapPlatformBox = (props) => {
  const { data } = props;

  return (
    <div className="overlap-platform-box">
      <span className="overlap-platform-box__label">
        <IDHFormattedMessage
          id="ws_social_platform"
          defaultMessage="Social platform"
        />
      </span>
      <div className="overlap-platform-box__data">
        <img src={SOCIAL_ICONS[data.provider]} alt={data.provider} />
        {SOCIAL_LABELS[data.provider]}
      </div>
    </div>
  );
};
